// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".view-result__title[data-v-d88dc06a]{text-align:left}@media(min-width:768px){.view-result__title[data-v-d88dc06a]{text-align:center}}.view-result__loading[data-v-d88dc06a]{position:absolute;top:0;left:0;width:100%;height:70%;background-image:url(/img/loaders/loader.svg);background-repeat:no-repeat;background-position:50%;background-size:36px auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
